var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isAiTaggingTourVisible)?_c(_setup.AiTaggingTour):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }